import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { GUID_EMPTY } from '@core';
import { _HttpClient } from '@delon/theme';

@Injectable()
export class ArKnockoffService {
  constructor(private http: _HttpClient) {}

  url = 'api/ARKnockoff/Query';
  loading = false;

  private _knockoffItems: any[] = [];
  get knockoffItems() {
    return this._knockoffItems;
  }
  set knockoffItems(val: any[]) {
    this._knockoffItems = val;
  }

  /**
   * Returns a Promise that resolves with the current knockoff items.
   * Used when callers need to wait for reload() to have run (reload is async).
   */
  fetchKnockoff(): Promise<any[]> {
    return Promise.resolve(this.knockoffItems);
  }

  /**
   * Load knockoff items from API. Returns an Observable that emits when the request completes.
   * Subscribe to update the grid after data is set.
   */
  reload(
    customerId: any,
    docType: string,
    docId: string,
    autoMapData: any = [],
    toKnockoff: any[]
  ): Observable<any[]> {
    const queryParams: any = {
      customerId: customerId,
      docType: docType
    };
    if (docId && docId !== '0' && docId !== GUID_EMPTY) {
      queryParams.docId = docId;
    }
    if (!queryParams.docType || !queryParams.customerId) {
      this.knockoffItems = [];
      return of(this.knockoffItems);
    }
    const toKnockoffIds = Array.isArray(toKnockoff) ? toKnockoff : [];
    return this.http.get(this.url, queryParams).pipe(
      map(res => {
        const raw = Array.isArray(res) ? res : (res?.data ?? []);
        if (!autoMapData || autoMapData.length === 0) {
          this.knockoffItems = raw;
          this.knockoffItems.forEach(item => {
            if (toKnockoffIds.includes(item.docId)) {
              item.paymentAmount = item.outstandingAmount;
            }
          });
        } else {
          this.knockoffItems = raw.map((item: any) => {
            const autoMap = autoMapData.find(
              (x: any) => x.docId === item.docId
            );
            if (autoMap) item.paymentAmount = autoMap.paymentAmount;
            return item;
          });
        }
        return this.knockoffItems;
      })
    );
  }

  get matchedAmount() {
    let result: number = 0;
    if (this.knockoffItems?.length) {
      this.knockoffItems
        .filter(x => x.paymentAmount !== 0)
        .forEach(item => {
          result += item.paymentAmount;
        });
    }
    return +result.toFixed(2);
  }

  // mergeMatchedItems(matchedData: any[]) {
  //   matchedData.forEach(matchedItem => {
  //     const found = this.knockoffItems.find(x => x.docId === matchedItem.docId);
  //     if (found) {
  //       Object.assign(found, matchedItem);
  //     } else {
  //       this.knockoffItems.push(matchedItem);
  //     }
  //   });
  //   // This to trigger the table's data source changed event and refresh the display
  //   this.knockoffItems = [...this.knockoffItems];
  // }
}
